//
//
//
//
//
//
//
//
//
//
//
//
//

import rbDynamicGridColumn from '../../smart-container/dynamic-grid-column'

export default {
  components: {
    rbDynamicGridColumn,
  },
  props: {
    slideSlot: {
      type: Array,
      default: () => [],
    },
  },
}
